import React from 'react';

function IpBlocked() {
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        zIndex: 200,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#e0e0e0', // light grey
        color: '#333',
          
      }}
    >
        <h1>Unauthorised Access</h1>
        <p style={{color:'gray',marginTop:'10px'}}> You are not authorised to access the portal please check with system administrator.
   
            </p>
      </div>
  );
}

export default IpBlocked;
